<template>
  <div id="modalSubUserGroupNew" class="modal fade">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="!canSubmit"></modal-loading>
        <div class="modal-header pd-x-20">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ info ? $t("subuser.修改角色") : $t("subuser.新建角色") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <form>
            <h6 class="tx-14 tx-uppercase tx-inverse tx-bold">
              {{ $t("subuser.角色名称") }}
            </h6>
            <div class="form-group mg-b-5">
              <input
                class="form-control form-control"
                type="text"
                v-model="groupName"
                :placeholder="$t('subuser.请输入角色名称')"
                maxlength="24"
              />
            </div>
            <h6 class="tx-14 mg-t-30 mg-b-0tx-uppercase tx-inverse tx-bold">
              {{ $t("subuser.是否拥有超级管理员权限") }}
            </h6>
            <div class="form-group">
              <div class="form-group mg-b-0 mg-t-15">
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="isSuper"
                      value="1"
                      v-model="isSuper"
                    />
                    <span>{{ $t("mall.是") }}</span>
                  </label>
                </div>
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="isSuper"
                      value="2"
                      v-model="isSuper"
                    />
                    <span>{{ $t("mall.否") }}</span>
                  </label>
                </div>
              </div>
            </div>
            <h6 class="tx-14 mg-t-30 mg-b-0tx-uppercase tx-inverse tx-bold">
              {{ $t("subuser.客户查看权限") }}
            </h6>
            <div class="form-group">
              <div class="form-group mg-b-0 mg-t-15">
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="roleType"
                      value="2"
                      v-model="roleType"
                    />
                    <span>{{ $t("subuser.全部客户") }}</span>
                  </label>
                </div>
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="roleType"
                      value="1"
                      v-model="roleType"
                    />
                    <span>{{
                      $t("subuser.已关联客户+未关联子账号的客户")
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
            <h6
              v-show="isSuper == 2"
              class="tx-14 mg-t-30 mg-b-0tx-uppercase tx-inverse tx-bold"
            >
              {{ $t("subuser.配置权限") }}
            </h6>
            <div
              v-show="isSuper == 2"
              class="form-group system-rights"
              v-for="(item, index) in systemRightsLi"
              :key="index"
            >
              <div class="form-group mg-b-0 mg-t-15">
                <label class="ckbox checkbox">
                  <input
                    type="checkbox"
                    :checked="item.checked"
                    @change="changeAllCheck(index)"
                  />
                  <span class="tx-black tx-normal">{{
                    (lang == "zh" && item.name) ||
                    (lang == "en" && item.nameEn) ||
                    item.name
                  }}</span>
                </label>
              </div>
              <div class="form-group row" v-if="item && item.subMenu">
                <div class="col-md-1"></div>
                <div class="col-md-11 col-sm-12">
                  <div
                    class="form-check form-check-inline pd-r-10"
                    v-for="(sub, indexsub) in item.subMenu"
                    :key="indexsub"
                    :class="sub && sub.subMenu ? 'sub-menu' : ''"
                  >
                    <label class="ckbox checkbox">
                      <input
                        type="checkbox"
                        :value="sub.key"
                        :checked="sub.checked"
                        @change="changeAllCheckSub(index, indexsub)"
                      />
                      <span class="tx-gray-800">{{
                        (lang == "zh" && sub.name) ||
                        (lang == "en" && sub.nameEn) ||
                        sub.name
                      }}</span>
                    </label>
                    <div
                      class="form-group row mg-b-0"
                      v-if="sub && sub.subMenu"
                    >
                      <div class="col-md-1"></div>
                      <div class="col-md-11 col-sm-12">
                        <div
                          class="form-check form-check-inline pd-r-10"
                          v-for="(subSub, indexsubs) in sub.subMenu"
                          :key="indexsubs"
                        >
                          <label class="ckbox checkbox">
                            <input
                              type="checkbox"
                              :value="subSub.key"
                              :checked="subSub.checked"
                              @change="
                                changeAllCheckSubSub(index, indexsub, indexsubs)
                              "
                            />
                            <span class="tx-gray-600">{{
                              (lang == "zh" && subSub.name) ||
                              (lang == "en" && subSub.nameEn) ||
                              subSub.name
                            }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h6 class="tx-14 mg-t-30 mg-b-0tx-uppercase tx-inverse tx-bold">
              {{ $t("subuser.是否允许查看金额") }}
            </h6>
            <div class="form-group">
              <div class="form-group mg-b-0 mg-t-15">
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="amountShow"
                      value="1"
                      v-model="amountShow"
                    />
                    <span>{{ $t("mall.是") }}</span>
                  </label>
                </div>
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="amountShow"
                      value="2"
                      v-model="amountShow"
                    />
                    <span>{{ $t("mall.否") }}</span>
                  </label>
                </div>
              </div>
            </div>
            <h6 class="tx-14 mg-t-30 mg-b-0tx-uppercase tx-inverse tx-bold">
              {{ $t("subuser.是否允许查看合同") }}
            </h6>
            <div class="form-group">
              <div class="form-group mg-b-0 mg-t-15">
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="showContract"
                      value="1"
                      v-model="showContract"
                    />
                    <span>{{ $t("mall.是") }}</span>
                  </label>
                </div>
                <div class="form-check form-check-inline pd-r-10">
                  <label class="rdiobox">
                    <input
                      type="radio"
                      name="showContract"
                      value="2"
                      v-model="showContract"
                    />
                    <span>{{ $t("mall.否") }}</span>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer pos-relative">
          <a
            v-if="info"
            href="javascript:;"
            class="tx-info pos-absolute l-15"
            @click="saveGroupNew"
            >{{ $t("subuser.保存为新角色") }}</a
          >
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
              mg-r-5
            "
            @click="saveGroup"
          >
            {{ $t("subuser.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("subuser.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: Number,
    info: {
      type: [Object, String],
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      canSubmit: true,
      groupName: "",
      isSuper: "",
      amountShow: "",
      showContract: "",
      roleType: "",
      systemRightsLi: [],
      lang: localStorage.getItem("ourmallVendorLang") || this.$i18n.locale,
    };
  },
  watch: {
    open: function () {
      this.groupName = this.info ? this.info.name : "";
      this.isSuper = this.info ? this.info.isSuper : "";
      this.roleType = this.info ? this.info.roleType : "";
      this.amountShow = this.info ? this.info.amountShow : "";
      this.showContract = this.info ? this.info.showContract : "";
      this.getSystemRights();
    },
  },
  methods: {
    changeAllCheckSubSub(i, t, j) {
      this.$set(
        this.systemRightsLi[i].subMenu[t].subMenu[j],
        "checked",
        !this.systemRightsLi[i].subMenu[t].subMenu[j].checked
      );
      let num = 0;
      this.systemRightsLi[i].subMenu[t].subMenu.forEach((x, y) => {
        if (x.checked) {
          num++;
        }
      });
      this.systemRightsLi[i].subMenu[t].checked =
        num == this.systemRightsLi[i].subMenu[t].subMenu.length ? true : false;
      let num2 = 0;
      this.systemRightsLi[i].subMenu.forEach((s, q) => {
        if (s.checked) {
          num2++;
        }
      });
      this.systemRightsLi[i].checked =
        num2 == this.systemRightsLi[i].subMenu.length ? true : false;
    },
    changeAllCheckSub(i, t) {
      this.$set(
        this.systemRightsLi[i].subMenu[t],
        "checked",
        !this.systemRightsLi[i].subMenu[t].checked
      );
      if (this.systemRightsLi[i].subMenu[t].checked) {
        if (this.systemRightsLi[i].subMenu[t].subMenu) {
          this.systemRightsLi[i].subMenu[t].subMenu.forEach((x, y) => {
            this.$set(x, "checked", true);
          });
        }
      } else {
        if (this.systemRightsLi[i].subMenu[t].subMenu) {
          this.systemRightsLi[i].subMenu[t].subMenu.forEach((x, y) => {
            this.$set(x, "checked", false);
          });
        }
      }
      let num = 0;
      this.systemRightsLi[i].subMenu.forEach((s, q) => {
        if (s.checked) {
          num++;
        }
      });
      this.systemRightsLi[i].checked =
        num == this.systemRightsLi[i].subMenu.length ? true : false;
    },
    changeAllCheck(i) {
      this.$set(
        this.systemRightsLi[i],
        "checked",
        !this.systemRightsLi[i].checked
      );
      if (this.systemRightsLi[i].checked) {
        this.systemRightsLi[i].subMenu.forEach((s, q) => {
          this.$set(s, "checked", true);
          if (s.subMenu) {
            s.subMenu.forEach((x, y) => {
              this.$set(x, "checked", true);
            });
          }
        });
      } else {
        this.systemRightsLi[i].subMenu.forEach((s, q) => {
          this.$set(s, "checked", false);
          if (s.subMenu) {
            s.subMenu.forEach((x, y) => {
              this.$set(x, "checked", false);
            });
          }
        });
      }
    },
    getSystemRights() {
      this.systemRightsLi = [];
      let vm = this;
      let getData = (data) => {
        this.systemRightsLi = data;
        this.systemRightsLi.forEach((e, i) => {
          this.$set(e, "checked", false);
          e.subMenu.forEach((s, q) => {
            this.$set(s, "checked", false);
            if (s.subMenu) {
              s.subMenu.forEach((x, y) => {
                this.$set(x, "checked", false);
              });
            }
          });
        });
        if (this.info && this.info.newRights) {
          this.info.newRights.forEach((b) => {
            this.systemRightsLi.forEach((e, i) => {
              e.subMenu.forEach((s, q) => {
                if (s.subMenu) {
                  s.subMenu.forEach((x, y) => {
                    if (x.key == b) {
                      this.$set(x, "checked", true);
                    }
                  });
                } else {
                  if (s.key == b) {
                    this.$set(s, "checked", true);
                  }
                }
              });
            });
          });
          this.systemRightsLi.forEach((e, i) => {
            this.$set(e, "num", 0);
            e.subMenu.forEach((s, q) => {
              this.$set(s, "num2", 0);
              if (s.subMenu) {
                s.subMenu.forEach((x, y) => {
                  if (x.checked) {
                    this.$set(s, "num2", s.num2 + 1);
                  }
                });
                this.$set(
                  s,
                  "checked",
                  s.num2 == s.subMenu.length ? true : false
                );
              }
              if (s.checked) {
                this.$set(e, "num", e.num + 1);
              }
              this.$set(e, "checked", e.num == e.subMenu.length ? true : false);
            });
          });
        }
      };
      this.canSubmit = false;
      $.api_call(
        "api.UserRole.getSystemRightsNew",
        { userType: 2 },
        function (r) {
          vm.canSubmit = true;
          if (r.ErrorCode == "9999") {
            getData(r.Data.Results);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveGroupNew() {
      if (!this.canSubmit) return;
      let vm = this;
      let rights = [];
      this.systemRightsLi.forEach((e, i) => {
        e.subMenu.forEach((s, q) => {
          if (s.subMenu) {
            s.subMenu.forEach((x, y) => {
              if (x.checked) {
                rights.push(x.key);
              }
            });
          } else {
            if (s.checked) {
              rights.push(s.key);
            }
          }
        });
      });
      this.canSubmit = false;
      $.api_call(
        "api.UserRole.addUserRole",
        {
          name: vm.groupName,
          newRights: rights,
          roleType: vm.roleType,
          isSuper: vm.isSuper,
          amountShow: vm.amountShow,
          showContract: vm.showContract,
        },
        (r) => {
          vm.canSubmit = true;
          if (r.ErrorCode == "9999") {
            this.$parent.getRoleList();
            $("#modalSubUserGroupNew").modal("hide");
            ShowTip(this.$t("subuser.新建角色组成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveGroup() {
      if (!this.canSubmit) return;
      let vm = this;
      let rights = [];
      this.systemRightsLi.forEach((e, i) => {
        e.subMenu.forEach((s, q) => {
          if (s.subMenu) {
            s.subMenu.forEach((x, y) => {
              if (x.checked) {
                rights.push(x.key);
              }
            });
          } else {
            if (s.checked) {
              rights.push(s.key);
            }
          }
        });
      });
      this.canSubmit = false;
      if (vm.info) {
        $.api_call(
          "api.UserRole.changeUserRole",
          {
            id: vm.info.id,
            name: vm.groupName,
            newRights: rights,
            roleType: vm.roleType,
            isSuper: vm.isSuper,
            amountShow: vm.amountShow,
            showContract: vm.showContract,
          },
          (r) => {
            vm.canSubmit = true;
            if (r.ErrorCode == "9999") {
              this.$parent.getRoleList();
              $("#modalSubUserGroupNew").modal("hide");
              ShowTip(this.$t("subuser.修改角色组成功"), "success");
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(vm);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      } else {
        $.api_call(
          "api.UserRole.addUserRole",
          {
            name: vm.groupName,
            newRights: rights,
            roleType: vm.roleType,
            isSuper: vm.isSuper,
            amountShow: vm.amountShow,
            showContract: vm.showContract,
          },
          (r) => {
            vm.canSubmit = true;
            if (r.ErrorCode == "9999") {
              this.$parent.getRoleList();
              $("#modalSubUserGroupNew").modal("hide");
              ShowTip(this.$t("subuser.新建角色组成功"), "success");
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(vm);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      }
    },
  },
};
</script>

<style>
.system-rights {
  background: #eee;
  padding: 1px 15px 1px;
}
.system-rights .sub-menu {
  display: block;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.system-rights .sub-menu:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
</style>